import React from 'react'
import PageChrome from '../../common/PageChrome'
import BlogDetail from './BlogDetail';

export default function index() {
  return (
    <PageChrome>
      <BlogDetail/>
    </PageChrome>
  )
}
